export default "__VITE_ASSET__FzQjm7zK__"